angular.module('rjmNg.directives').directive "metricEdit", [
  () ->
    restrict: "E"
    templateUrl: "directive.metricEdit.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    scope: {}
    controller: [
      "$location"
      "$rootScope"
      "$routeParams"
      "$q"
      "$url"
      "$window"
      "app"
      "appRoute"
      "dependencyEnums"
      "Dimensions"
      "metricEnums"
      "Metrics"
      "notification"
      "operatorEnums"
      "StructureCache"
      "userService"
      (
        $location
        $rootScope
        $routeParams
        $q
        $url
        $window
        app
        appRoute
        dependencyEnums
        Dimensions
        metricEnums
        Metrics
        notification
        operatorEnums
        StructureCache
        userService
      ) ->

        view = @
        _idToGet = null
        _metricToUpdate = null
        _name = ''
        _noneTimeCol = {
          name: '[NONE]'
          id: null
        }
        _taStates = 
          all: 'rj-icon rj-icon--check-square-o'
          some: 'rj-icon rj-icon--minus-square-o'
          none: 'rj-icon rj-icon--square-o'

        _aggFns = _.reduce(metricEnums.AGGREGATE_FUNCTIONS_IDS, (accu, id, key) -> 
          accu[key] = {
            id: id
            name: metricEnums.AGGREGATE_FUNCTIONS[key] || ''
            code: key
          }
          return accu
        , {})
        _notificationTimeout = 15
        _originalUserList = []
        _tablesMap = {}

        # Dep Resolver
        view.showDR = false
        view.depConfirmMsg = "Delete dimension(s) and reports?"
        view.depResourceType = dependencyEnums.RESOURCE_TYPES.DIMENSION
        view.depPromises = {}
        view.depNames = {}

        view.availableDimensions = []
        view.metricDimensions = []
        view.calcColumnOptions = []
        view.calcIsSubscription = false
        view.cancelEditUrl = appRoute("/settings/metric/")
        view.isDirty = false
        view.isEdit = false
        view.globalSwap = true
        view.loading = false
        view.metricInfo = {}
        view.metricDimensions = []
        view.readyToSave = false
        view.selectedTable = null
        view.showDelete = false
        view.tableIds = []
        view.tableList = []
        view.userListLoading = false

        view.filters =
          restrictions: []
          sequence:
            string: null
            errorMessage: null
        view.filtersValid = true


        _confirmNavigation = (event) ->
          if view.isDirty
            if not confirm "Leaving this page will discard your current changes.\n\nDiscard your current changes?"
              event?.preventDefault()
              return false
            else
          return true

        _createSaveableRestrictions = (restrictions) ->
          restrictions.map((item) ->
            if(!item.filter_set_id)
              tempItem = {}
              tempItem.left = item.left
              tempItem.operation = operatorEnums.COMPARISON_OPERATOR_SYMBOLS[item.op]
              tempItem.right = {}
              tempItem.right.value = if item.right is '[NULL]' then null else item.right
              return tempItem
            else
              return item
          )      

        _initDataLoads = () ->
          return $q.all([
            _loadStructureInfo()
            _loadUserList()
          ])

        _findAggFn = (code) ->
          _.find(_aggFns, (fn) -> return fn.code is code)

        _findCol = (id) ->
          _.find(view.selectedTable.columns, (col) -> return col.id is id)

        _handleGenericLoadError = (error) ->
          console.log(error)
          notification.error("Server Error",
              errorConstants.SERVER_ERROR_MESSAGE,
              "metricEdit",
              null,
              _notificationTimeout
            )
          $window.scrollTo(0,0)

        _handleMetricUpdateError = (error) ->
          console.log(error)
          notification.error("Server Error",
              "Error updating metric, please try again or contact support.",
              "metricEdit",
              null,
              _notificationTimeout
            )
          $window.scrollTo(0,0)

        _handleSuccessUpdate = (msg, metric) ->
          _metricToUpdate = metric
          _updateMetric(_metricToUpdate, true)
          notification.success("Success",
              msg,
              "metricEdit",
              null,
              _notificationTimeout
            )
          $window.scrollTo(0,0)

        _loadStructureInfo = () ->
          deffered = $q.defer()
          StructureCache.getStructure().then((success)->
            _tablesMap = angular.copy(success.tables)
            view.tableList = _.chain(_tablesMap)
                              .map((tb) ->
                                tb.hasSubscription = false
                                if(tb.columns)
                                  tb.columns.map((col)->
                                    col.is_groupable = Metrics.guessGroupable(col)
                                    col.column_id = col.id
                                    col.datatype = col.old_data_type
                                    if(col.properties.derivative_type is 'subscription_id')
                                      tb.hasSubscription = true
                                  )
                                  tb.columns = _.sortBy(tb.columns, _sortByName)
                                tb
                              ).sortBy(_sortByName)
                              .value()
            view.columnsMap = angular.copy(success.columns)           
            deffered.resolve()
          ,(error) ->
            _handleGenericLoadError(error)
            deffered.reject(error)
          )
          return deffered

        _loadUserList = () ->
          deffered = $q.defer()
          view.userListLoading = true
          userService.query({clientId: view.clientId}).then((success)->
            metId = _idToGet
            view.userList = _.chain(angular.copy(success))
                             .filter((user) -> return !user.client_rights.is_admin )
                             .map((user) ->
                              isSelected = true
                              if(metId)
                                isSelected = _.find(user.client_rights.trend_rights, (met) -> return met.id is parseInt(metId, 10) ).has_rights
                              temp = {
                                uid: user.id
                                access: true
                                isSelected: isSelected
                                name: user.name
                              }
                              return temp
                             ).value()
            view.allUser = true
            _originalUserList = angular.copy(view.userList)
            view.setAllUsers()
            view.isDirty = false
            deffered.resolve()
          , (error) ->
            _handleGenericLoadError(error)
            deffered.reject(error)
          ).finally(() ->
            view.userListLoading = false
          )
          return deffered

        _saveDimensions = (newDims) ->
          view.loading = true
          if(view.isEdit)
            ogDims = _metricToUpdate.dimensions
            dimsToUpdate = _.map(newDims, (col) -> return { column_id: col.id, is_groupable: col.is_groupable } )
            tempMet = _metricToUpdate
            tempMet.dimensions = Metrics.resolveDimensions(ogDims, dimsToUpdate)
            tempMet.filters = _createSaveableRestrictions(view.filters.restrictions)
            Metrics.update(app.getClientId(), tempMet.id, tempMet).then((success) ->
              _handleSuccessUpdate("Successfully updated Metric dimensions.", success)
            ,(error) ->
              _handleMetricUpdateError(error)
              _metricToUpdate.dimensions = ogDims
            ).finally(() ->
              view.loading = false
              _setDimensions(_metricToUpdate.dimensions)
            )

        _saveMetric = () ->
          view.loading = true
          dimensionsToSave = _.map(view.metricDimensions, (col) -> return { column_id: col.id, is_groupable: col.is_groupable } )
          metricToSave =
            "operation_column_id": view.selectedCalcColumn.id,
            "timestamp_column_id": if !view.calcIsSubscription then view.selectedTimeCol.id else null,
            "subscription_column_id": if view.calcIsSubscription then view.selectedSubCol.id else null,
            "subscription_start_column_id": if view.calcIsSubscription then view.selectedSubStart.id else null,
            "subscription_end_column_id": if view.calcIsSubscription then view.selectedSubEnd.id else null,
            "name": _name,
            "command": if view.selectedOperation.code.slice(0,3) is 'SUB' then view.selectedOperation.code.slice(4) else view.selectedOperation.code,
            "table_id": view.selectedTable.id,
            "dimensions": dimensionsToSave,
            "filters": _createSaveableRestrictions(view.filters.restrictions),
            "sequence": view.filters.sequence.string
          
          saveFn = Metrics.create.bind(null, app.getClientId(), metricToSave)
          saveMsg = "Successfully created new metric."
          if(_metricToUpdate)
            saveMsg = "Successfully updated metric."
            metricToSave.id = _metricToUpdate.id
            saveFn = Metrics.update.bind(null, app.getClientId(), metricToSave.id, metricToSave)
            metricToSave.dimensions = Metrics.resolveDimensions(_metricToUpdate.dimensions, dimensionsToSave)

          saveFn().then((success) ->
              _handleSuccessUpdate(saveMsg, success)
              _saveUserPermissions(success.id).finally(() ->
                view.loading = false
              )

              if(!view.isEdit)
                $location.path(appRoute("/settings/metric/edit/" + success.id))
            ,(err) ->
              view.loading = false
              _handleMetricUpdateError(err)
            ).finally(() ->
              view.isDirty = false
            )
        
        _setDimensions = (metricDimensions, isNew) ->
          view.metricDimensions = _.chain(_metricToUpdate.dimensions)
                                  .filter((dim) -> return dim.column_id )
                                  .map((dim) ->
                                    return angular.merge({ isSaved: if isNew then false else true}, _findCol(dim.column_id), dim)
                                  )
                                  .value()
          view.availableDimensions = _.reject(view.selectedTable.columns, (dim) -> return _.find(view.metricDimensions, (metDim) -> return metDim.id is dim.id ))
          _setAllGroupable()

        _saveUserPermissions = (metricId) ->
          updateList = []
          ogCopy = _.sortBy(_originalUserList, 'id')
          newCopy = _.sortBy(view.userList, 'id')
          _.each(newCopy, (val, ix) ->
            if(ogCopy[ix].isSelected isnt val.isSelected)
              updateList.push(Metrics.setUserRights(app.getClientId(), metricId, val.uid, val.isSelected))
          )
          $q.all(updateList).then((success) ->
            #notifcation should be handled
            success
          ,(error) ->
            notification.error("Error",
              "Error updating user permissions, please try again or contact support.",
              "metricEdit",
              null,
              _notificationTimeout
            )
            console.log(error)
          )

        _setAllGroupable = () ->
          view.allGroupableState = _setToggleAllState(view.metricDimensions, 'is_groupable')

        _setCalcTypeByCol = () ->
          col = view.selectedCalcColumn
          view.calcOptions = Metrics.getCalcTypeByCol(col, view.selectedTable, view.columnsMap)
          if(view.selectedOperation && !_.find(view.calcOptions, (option) -> return option.id is view.selectedOperation.id))
            view.selectedOperation = null

        _setDefaultCol = () ->
          if(view.selectedTable.columns)
            resultCol = _.chain(view.selectedTable.columns)
                        .filter((col) -> return col.is_primary_key )
                        .sortBy(_sortByName)
                        .first()
                        .value()
            if(resultCol)
              view.selectedCalcColumn = resultCol
            else
              view.selectedCalcColumn = _.chain(view.selectedTable.columns)
                                      .sortBy(_sortByName )
                                      .first()
                                      .value()
            _setCalcTypeByCol()

        _setSubscriptionCol = () ->
          view.calcIsSubscription = null
          view.selectedSubCol = null
          view.selectedSubStart = null
          view.selectedSubEnd = null
          if(view.selectedTable.hasSubscription)
            view.subscriptionOptions = _.chain(view.selectedTable.columns)
                                      .filter((col) -> return col.properties.derivative_type is 'subscription_id')
                                      .sortBy(_sortByName )
                                      .value()

        _setTimeCol = () ->
          view.selectedTimeCol = null
          timeOptions = _.chain(view.selectedTable.columns)
                         .filter((col) -> return col.field_type is 'datetime' )
                         .sortBy(_sortByName)
                         .value()
          view.subTimeColOptions = timeOptions
          view.timeColOptions = [_noneTimeCol].concat(timeOptions)

        _setToggleAllState = (list, flag)->
          resultState = _taStates.all
          tempList = list.filter((item) -> return item[flag] )
          if(tempList.length is 0)
            resultState = _taStates.none
          else if(tempList.length isnt list.length)
            resultState = _taStates.some
          return resultState

        _sortByName = (val) ->
          return val.name.toLowerCase()

        _updateMetric = (metricInfo, isEdit) ->
          if(isEdit)
            view.migrateUrl = $url("") + "/settings/#{app.getClientId()}/trend/#{metricInfo.id}/migrate/"
            _name = metricInfo.name
          else
            _name ='Copy of ' +  metricInfo.name

          view.displayName = _name
          view.setTable(_tablesMap[metricInfo.table_id])
          view.selectCalcColumn(_findCol(metricInfo.operation_column_id))
          if(metricInfo.subscription_column_id)
            view.setOperation(_findAggFn('SUB_' + metricInfo.command))
            view.setSubColumn(_findCol(metricInfo.subscription_column_id))
            view.setSubStart(_findCol(metricInfo.subscription_start_column_id))
            view.setSubEnd(_findCol(metricInfo.subscription_end_column_id))
          else
            view.setOperation(_findAggFn(metricInfo.command))
            if(metricInfo.timestamp_column_id)
              view.setTimeColumn(_findCol(metricInfo.timestamp_column_id))
            else
              view.setTimeColumn(_noneTimeCol)

          _setDimensions(metricInfo.dimensions, !isEdit)

          if(metricInfo.filters.length > 0)
            view.filtersOpen = true
            view.filters.restrictions = metricInfo.filters.map((fil) ->
              if(!fil.filter_set_id)
                fil.right = fil.right.value
                fil.op = operatorEnums.COMPARISON_OPERATOR_IDS[fil.operation]
              fil
            )
            view.filters.sequence.string = metricInfo.sequence

        _validateMetric = () ->
          view.readyToSave = false
          isValid = false
          if(_name && view.selectedTable && view.selectCalcColumn && view.selectedOperation && view.filtersValid)
            if(!view.calcIsSubscription && view.selectedTimeCol)
              isValid = true
            if(view.calcIsSubscription && view.selectedSubCol && view.selectedSubStart && view.selectedSubEnd)
              isValid = true
          view.readyToSave = isValid

        view.addDimension = () ->
          view.isDirty = true
          view.selectedColToAdd.isSaved = false
          view.selectedColToAdd.isDelete = false
          view.metricDimensions.push(view.selectedColToAdd)
          view.availableDimensions = _.reject(view.availableDimensions, (dim) -> dim.id is view.selectedColToAdd.id)
          _setAllGroupable()
          view.selectedColToAdd = null

        view.confirmDelete = (selections) ->
          view.loading = true
          updatedDims = _.reject(view.metricDimensions, (metDims) -> return selections[metDims.id] && selections[metDims.id].selected)
          _saveDimensions(updatedDims).then((success) ->
            
          (error) ->
            _handleMetricUpdateError(error)
          ).finally(() -> 
            view.loading = false
            view.showDelete = false
          )

        view.dimDelete = (dim) ->
          view.isDirty = true
          depToDel = _.filter(view.metricDimensions, (dim) -> return dim.isDelete )
          if(depToDel.length > 0)
            view.showDelete = true
          else
            view.showDelete = false

        view.showDimDependencies = () ->
          if(view.isEdit)
            view.availableDimensions = view.availableDimensions.concat(_.filter(view.metricDimensions, (dim) -> return dim.isDelete &&  !dim.isSaved))
            view.metricDimensions = _.reject(view.metricDimensions, (dim) -> return dim.isDelete &&  !dim.isSaved)
            depToDel = _.filter(view.metricDimensions, (dim) -> return dim.isDelete )
            if(depToDel.length > 0)
              view.depPromises = {}
              view.depNames = {}
              depToDel.map((dim) -> 
                dimKey = dim.id
                view.depPromises[dimKey] = Dimensions.dependents(
                        clientId: app.getClientId()
                        metricId: _metricToUpdate.id
                        columnId: dim.id
                      ).$promise
                view.depNames[dimKey] = 
                  name: dim.name
              )
              view.showDR = true
            else
              view.showDelete = false
          else
            view.availableDimensions = view.availableDimensions.concat(_.filter(view.metricDimensions, (dim) -> return dim.isDelete))
            view.metricDimensions = _.reject(view.metricDimensions, (dim) -> return dim.isDelete)
            view.showDelete = false
          _setAllGroupable()

        view.closeFilters = () ->
          view.isDirty = true
          view.filtersOpen = false
          view.filters =
          restrictions: []
          sequence:
            string: null
            errorMessage: null

        view.focusName = () ->
          if(_name.trim() is '')
            view.displayName = ''

        view.groupChanged = () ->
          view.isDirty = true
          _setAllGroupable()

        view.openFilters = () ->
          view.isDirty = true
          view.filtersOpen = true

        view.openSwapDimension = (id) ->
          view.swapId = id
          view.globalSwap = true

        

        view.setAllUsers = () ->
          view.isDirty = true
          view.allUsersState = _setToggleAllState(view.userList, 'isSelected')
        
        view.saveMetric = () ->
          _saveMetric()

        view.setTable = (table) ->
          view.isDirty = true
          view.selectedTable = table
          view.tableIds = [table.id]
          view.metricDimensions = view.selectedTable.columns
          _setDefaultCol()
          _setTimeCol()
          _setSubscriptionCol()
          _validateMetric()
          _setAllGroupable()

        view.setOperation = (op) ->
          view.isDirty = true
          view.selectedOperation = op
          view.calcIsSubscription = false
          if(op.code.slice(0,3) is 'SUB')
            view.calcIsSubscription = true
          _validateMetric()

        view.selectCalcColumn = (col) ->
          view.isDirty = true
          view.selectedCalcColumn = col
          _setCalcTypeByCol()
          _setSubscriptionCol()
          _validateMetric()

        view.setSubStart = (col) ->
          view.isDirty = true
          view.selectedSubStart = col
          _validateMetric()

        view.setSubEnd = (col) ->
          view.isDirty = true
          view.selectedSubEnd = col
          _validateMetric()
        
        view.setSubColumn = (col) ->
          view.isDirty = true
          view.selectedSubCol = col
          _validateMetric()

        view.setTimeColumn = (col) ->
          view.isDirty = true
          view.selectedTimeCol = col
          _validateMetric()

        view.swapDimension = (id) ->
          view.loading = true
          Metrics.swapDimension(app.getClientId(), _metricToUpdate.id, id, view.dimToSwap.id, view.globalSwap, view.dimToSwap.is_groupable).then((success) ->
            tempDim = angular.copy(view.dimToSwap)
            tempDim.isSaved = true
            view.metricDimensions.push(tempDim)
            view.availableDimensions.push(_.find(view.metricDimensions, (dimToRemove) -> dimToRemove.id is id))
            view.metricDimensions = _.reject(view.metricDimensions, (dimToRemove) -> dimToRemove.id is id)
            view.availableDimensions = _.reject(view.availableDimensions, (dim) -> dim.id is view.dimToSwap.id)
            if(success?.data?.alert)
              notification.info("Success",
                "Did not update following Metrics. " +success.data.alert.join(', '),
                "metricEdit",
                null,
                _notificationTimeout
              )
              $window.scrollTo(0,0)
          (error) ->
            _handleMetricUpdateError(error)
          ).finally(() ->
            view.dimToSwap = null
            view.loading = false
            view.swapId = null
            _setAllGroupable()
          )

        view.toggleAllUsers = () ->
          view.isDirty = true
          view.userList.map((user) -> user.isSelected = view.allUsersState isnt _taStates.all)

        view.toggleAllGroupable = () ->
          view.isDirty = true
          view.metricDimensions.map((dim) -> dim.is_groupable = view.allGroupableState isnt _taStates.all)
          _setAllGroupable()
          
        view.unfocusName = () ->
          if(_name.trim() is '')
            view.displayName = 'Untitled Metric'

        view.validateName = ($event) ->
          view.isDirty = true
          _name = $event.target.value
          view.displayName = _name
          _validateMetric()

        view.validateMetric = () ->
          _validateMetric()

        view.$postLink = () ->
          view.loading = true
          if($routeParams.metricId? || $routeParams.cloneId?)
              _idToGet = null
              if $routeParams.metricId?
                view.isEdit = true
                _idToGet = $routeParams.metricId
              else 
                _idToGet = $routeParams.cloneId
          _initDataLoads().then((success) ->
            if(_idToGet)
              Metrics.getFullMetricInfo(app.getClientId(), _idToGet).then(
                (success) ->
                  _metricToUpdate = success
                  _updateMetric(_metricToUpdate, view.isEdit)

                  if(!view.isEdit)
                    _metricToUpdate = null
                ,_handleGenericLoadError).finally(() ->
                view.loading = false
              )
            else
              view.displayName = 'Untitled Metric'
              view.loading = false
          ,(error) ->
            view.loading = false
            #error handled in each specific data load
          ).finally(()->
            view.isDirty = false
          )

        view.$onDestroy = () ->
          _confirmNavigation = () -> null
          $window.onbeforeunload = () -> 
            null
          changeLocationListener()

        changeLocationListener = $rootScope.$on '$locationChangeStart', (event, newState, oldState) ->
          _confirmNavigation(event)

        $window.onbeforeunload = () ->
          if view.isDirty
            return "Leaving this page will discard your current changes."

        return view
    ]

    link: (scope, elem, attrs, view) ->

      scope.$watch("view.filters", () ->
        view.validateMetric()
      , true)
      scope.$watch("view.filtersValid", () ->
        view.validateMetric()
      )


]
